import {Pipe, PipeTransform} from '@angular/core';
import {findTenderCostsRange} from '../utils';

@Pipe({
    name: 'tenderCostsRange',
    standalone: false
})
export class TenderCostsRangePipe implements PipeTransform {
    transform(value?: number | null): string {
        return findTenderCostsRange(value)?.label ?? '';
    }
}
